






























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ModuleOption, InformationCodes } from '@/data/enums'
import OptionModule from '@/components/OptionModule.vue'
import Loader from '@/components/ui/Loader.vue'
import GlassOption from '@/data/glass-option'
import GlassOptionValue from '@/data/glass-option-value'
import '@/icons/options-lifestyle'

@Component({
  components: {
    OptionModule,
    Loader
  }
})
export default class LifestyleModule extends Vue {
  private informationCode: string = InformationCodes.ModuleLifestyle
  private optionId: number = ModuleOption.Lifestyle
  private isLoading: boolean = true
  private currentBackground: string = '' // this.options[0].background

  private get background (): string {
    const currentItem = this.$store.state.cart.currentItem
    const lifeStyleOption = currentItem.type.options.find((option: GlassOption) => option.optionId === this.optionId)
    if (lifeStyleOption) {
      const selectedValue = lifeStyleOption.values.find((optionValue: GlassOptionValue) => (optionValue.selected))
      if (selectedValue) {
        return this.thumbnail(selectedValue.number)
      }
    }
    return ''
  }
  private thumbnail (id: number): string {
    switch (id) {
      case 90:
        return 'module/lifestyle/lifestyle_allround.png'
      case 91:
        return 'module/lifestyle/lifestyle_expert.png'
      case 92:
        return 'module/lifestyle/lifestyle_active.png'
    }
    return ''
  }

  @Watch('background')
  private onBackgroundChanged (val: string, oldVal: string) {
    this.isLoading = true
  }

  private get optionIds (): ModuleOption[] {
    return [this.optionId]
  }

  private onLoaded () {
    this.isLoading = false
  }

  private selectOption (optionValue: GlassOptionValue) {
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
